<template>
	<modal size="medium" @close="close">
		<template #header>
			<h3>{{ $t(`${capitalizedType} Warehouse`) }}</h3>
		</template>
		<template #body>
			<span>
				{{ $t(`Are You Sure want to ${type} warehouse with name : `) }} <span class="font-weight-bold">
					{{ warehouse.label }}
				</span>
			</span>
		</template>
		<template #footer>
			<!-- Cancel -->
			<button type="button" class="btn btn-light" @click="close">
				{{ $t("Cancel") }}
			</button>
			<!-- Submit -->
			<button class="btn btn-danger" :class="{ 'is-loading': isLoading }" @click="submit">
				<span>{{ $t(`${capitalizedType} Warehouse`) }}</span>
			</button>
		</template>
	</modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import warehouseApi from '@/api/warehouse';

export default {
	name: 'DeleteWarehouse',
	props: {
		warehouse: {
			type: Object,
			default: () => ({}),
		},
		type: {
			type: String,
			default: 'delete',
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			isLoading: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		submit() {
			const warehouseId = this.warehouse._id;
			const params = {
				created_by_admin: false,
			};
			if (this.user.role === 'admin' || this.user.role === 'superadmin') {
				params.created_by_admin = true;
				params.type = this.type;
			}
			const callback = (response) => {
				const warehouse = response.data;
				this.showNotify(
					this.$t(`${this.capitalizedType} Warehouse`),
					this.$t(`Warehouse ${this.capitalizedType}d Successfully`),
					'success',
				);
				this.$emit('set', warehouse);
				this.close();
			};
			const err = (e) => {
				console.log(e);
			};
			warehouseApi.deleteByAdmin(warehouseId, params, callback, err);
		},
		showNotify(title, text, type) {
			this.$notify({
				group: 'app',
				title,
				text,
				type,
			});
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		capitalizedType() {
			return this.type.charAt(0).toUpperCase() + this.type.slice(1);
		},
	},
};
</script>
